import { render, staticRenderFns } from "./GameLineups.vue?vue&type=template&id=535b868e"
import script from "./GameLineups.vue?vue&type=script&lang=js"
export * from "./GameLineups.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports